import React from 'react';
import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import type { Locales } from 'cms/cms-types';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

// import type { OptionTypeBase } from 'react-select';
export const VIEW_MAP = 'map';
export const VIEW_LISTING = 'listing';

export interface LocationListingCMSConfig {
    apiKey: string;
    apiUrl?: string;
}

export interface Coordinates {
    lat: number;
    lon: number;
}

interface LocationListingMap {
    apiKey: string;
    mapId: string;
    filters?: Filter[];
    filterByAncestors?: string[];
}

interface LocationListingLabel extends ListingUILabel {
    title: string;
    mapViewSwitchTitle: string;
    listViewSwitchTitle: string;
    filterHeading: string;
    clearFilterButton: string;
    telLabel: string;
    emailLabel: string;
    readMoreCardLabel: string;
}

interface LocationListingListing {
    filters?: Filter[];
    filterByAncestors?: string[];
    itemsPerPage: number;
}

export interface LocationListingProps {
    cms: LocationListingCMSConfig;
    locale?: Locales;
    label: LocationListingLabel;
    map: LocationListingMap;
    listing: LocationListingListing;
}

export type LocationListingView = typeof VIEW_MAP | typeof VIEW_LISTING;

export interface LocationListingContextProps extends LocationListingProps, ListingFiltersState {
    view: LocationListingView;
    setView: React.Dispatch<React.SetStateAction<LocationListingView>>;
    activeItemId: string;
    setActiveItemId: React.Dispatch<React.SetStateAction<string>>;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
}

const LocationListingContext = React.createContext<Partial<LocationListingContextProps>>({});

export default LocationListingContext;
